// The app has exactly two looks. Base is the absence of the attribute, so
// every stylesheet's defaults are the base look and only the memorial
// override block in src/styles/base/_tokens.scss needs to know about it.
export type AppTheme = 'base' | 'memorial';

export const THEME_STORAGE_KEY = 'appTheme';

export function applyTheme(theme: AppTheme): void {
    const root = document.documentElement;
    if (theme === 'memorial') {
        root.dataset.theme = 'memorial';
    } else {
        delete root.dataset.theme;
    }
}

// Storage can be missing or throwing (private mode, blocked site data);
// the theme is a convenience, so those cases just fall back to base.
export function readStoredTheme(): AppTheme {
    try {
        return localStorage.getItem(THEME_STORAGE_KEY) === 'memorial' ? 'memorial' : 'base';
    } catch (e) {
        return 'base';
    }
}

export function storeTheme(theme: AppTheme): void {
    try {
        localStorage.setItem(THEME_STORAGE_KEY, theme);
    } catch (e) {
        // ignore
    }
}
